/** Prefix of every access query, so one invalidation refreshes them all. */
export const ACCESS_QUERY_KEY = ["access"] as const;
export const FEATURES_QUERY_KEY = [...ACCESS_QUERY_KEY, "features"] as const;
export const ME_ACCESS_QUERY_KEY = [...ACCESS_QUERY_KEY, "me"] as const;
